import { render } from "./MonacoEditor.vue?vue&type=template&id=14a548d6"
import script from "./MonacoEditor.vue?vue&type=script&lang=js"
export * from "./MonacoEditor.vue?vue&type=script&lang=js"

import "./MonacoEditor.vue?vue&type=style&index=0&id=14a548d6&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__